export default __webpack_public_path__ + "static/media/GLOTrackPink.0f6c045c.svg";